import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

// Case- and accent-insensitive search key, so "oeuf" finds "Œufs" and "creme" finds "Crème".
export function searchKey(text) {
    return (text || '')
        .toLowerCase()
        .replace(/œ/g, 'oe')
        .replace(/æ/g, 'ae')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '');
}

// Menu price incl. VAT that makes `cost` the target share of the price excl. VAT, rounded up to 10 cents.
export const suggestedPrice = (cost, vatRate, targetFoodCost) => {
  if (!(cost > 0) || !(targetFoodCost > 0)) return null;
  const price = (cost / (targetFoodCost / 100)) * (1 + (vatRate || 0) / 100);
  return Math.ceil(price * 10 - 1e-9) / 10;
};

// Where an ingredient's price comes from, in the kitchen's words.
export const PRICE_SOURCE_LABEL = {
  invoice: 'Facture',
  webshop: 'Webshop',
  estimate: 'Estimation',
  sheet: 'Fiche recette',
  manual: 'Saisi à la main',
};

// e.g. "Facture du 29/10/2026", "Webshop, relevé le 02/11/2026".
export const priceOrigin = (source, date) => {
  const day = date ? new Date(date).toLocaleDateString('fr-BE', { day: '2-digit', month: '2-digit', year: 'numeric' }) : null;
  const label = PRICE_SOURCE_LABEL[source] || 'Source inconnue';
  if (!day) return label;
  if (source === 'invoice' || source === 'estimate' || source === 'sheet') return `${label} du ${day}`;
  if (source === 'webshop') return `${label}, relevé le ${day}`;
  if (source === 'manual') return `${label} le ${day}`;
  return `${label}, ${day}`;
};
